export const API_URL = process.env.REACT_APP_API_URL

export const DATA_API_URL = process.env.REACT_APP_DATA_API_URL
